import {ICreateAndUpdateSchool} from "../../../types/school.interface";
import {CREATE_SCHOOL_PARENT} from "./../../routes";
import customAxios from "../../customAxios";

const createSchoolParent = async (formData: ICreateAndUpdateSchool) => {
  try {
    return (
      await customAxios.post(CREATE_SCHOOL_PARENT, {
        lat: formData.lat,
        long: formData.long,
        name: formData.name,
        city: formData.city?._id,
        grade: formData.grade,
        address: formData.address,
        province: formData.province?._id,
        telephone: formData.telephone,
      })
    ).data;
  } catch (error: unknown) {
    console.error({CREATE_SCHOOL_PARENT: error});
    return false;
  }
};

export default createSchoolParent;
